import { render, staticRenderFns } from "./DetailAma.vue?vue&type=template&id=e9898444&scoped=true&"
import script from "./DetailAma.vue?vue&type=script&lang=js&"
export * from "./DetailAma.vue?vue&type=script&lang=js&"
import style0 from "./DetailAma.vue?vue&type=style&index=0&id=e9898444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9898444",
  null
  
)

export default component.exports